import { Link } from 'react-router-dom';
import type { ArticleCard } from '@nk/shared';
import { useLocale } from '@/i18n/locale-context';
import { formatDate, formatNumber } from '@/lib/format';

/** PRD §10's numbered list. Pinned stories arrive first — the API decides that, not this. */
export function TrendingList({ articles }: { articles: ArticleCard[] }) {
  const { locale } = useLocale();

  if (articles.length === 0) return null;

  return (
    <ol className="flex flex-col">
      {articles.map((article, position) => (
        <li key={article.id} className="border-b border-line last:border-b-0">
          <Link to={article.path} className="group grid grid-cols-[26px_1fr] gap-2.5 py-3.5">
            <span className="font-serif text-xl font-extrabold text-red">
              {formatNumber(position + 1, locale)}
            </span>
            <span className="min-w-0">
              <span className="block text-base font-bold text-ink transition group-hover:text-red">
                {article.headline}
              </span>
              <span className="mt-1 block text-xs text-muted">
                {formatDate(article.publishedAt, locale)}
              </span>
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}
